import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n';
import './index.css';
import OidcProvider from './OidcProvider';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import SubscriptionProvider from './SubscriptionProvider';
import { initAnalytics } from './platform/analytics';
import { captureFirstTouch } from './platform/attribution';
import { beginFunnelSession } from './platform/funnel';

// GR-001: the only place where analytics is started. Do not call the tracker
// from pages or components; use the helpers in src/platform/analytics.ts.
initAnalytics();

// GR-003: reads the campaign parameters of this load and keeps the first origin
// this device ever saw. Must run here, before anything can trigger the OIDC
// redirect, because the redirect destroys the query string.
captureFirstTouch();

// GR-002: counts this app start as one distinct session, which is what decides
// `activated` later. Must run before any funnel event is emitted.
beginFunnelSession();

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <OidcProvider>
      <SubscriptionProvider>
        <App />
      </SubscriptionProvider>
    </OidcProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
